import { setOverlayList } from "../../../../../stateManagement/reducers/MapSlice";
import { store } from "../../../../../stateManagement/store";

function getOverlayList() {
    const overlayList = store.getState().map.overlayList ?? [];
    return Array.isArray(overlayList) ? overlayList : [];
}

function isTransientOverlay(overlay: any) {
    return overlay?.type === "transportInfo";
}

function orderOverlayList(overlayList: any[]) {
    const staticOverlays = overlayList.filter((overlay) => !isTransientOverlay(overlay));
    const transientOverlays = overlayList.filter((overlay) => isTransientOverlay(overlay));
    return [...staticOverlays, ...transientOverlays];
}

export function removeOverlayFromStateById(overlayId?: string | number) {
    if (overlayId == null) return;

    const nextOverlayList = getOverlayList().filter((overlay) => overlay?.id !== overlayId);
    store.dispatch(setOverlayList(orderOverlayList(nextOverlayList)));
}

export function upsertOverlayInState(overlay: any) {
    if (!overlay?.id) return;

    const overlayList = getOverlayList().filter((item) => item?.id !== overlay.id);
    store.dispatch(setOverlayList(orderOverlayList([...overlayList, overlay])));
}

export function focusOverlayInState(overlayId?: string | number) {
    if (overlayId == null) return;

    const overlayList = getOverlayList();
    const focusedOverlay = overlayList.find((overlay) => overlay?.id === overlayId);
    if (!focusedOverlay || isTransientOverlay(focusedOverlay)) return;

    const nextOverlayList = overlayList.filter((overlay) => overlay?.id !== overlayId);
    store.dispatch(setOverlayList(orderOverlayList([...nextOverlayList, focusedOverlay])));
}
